import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aboutwala',
  templateUrl: './aboutwala.component.html',
  styleUrls: ['./aboutwala.component.css']
})
export class AboutwalaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
